import { FormGroup, ValidatorFn, ValidationErrors } from "@angular/forms";

export function PasswordMatchValidatorFactory(passname1: string, passname2: string): ValidatorFn{
    return (g: FormGroup) : ValidationErrors => {
        return g.get(passname1).value === g.get(passname2).value
            ? null : { 'mismatch': true };
    }
}

